<template>
  <div>
    <Card>
      <ui-not-found></ui-not-found>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

</script>
